<template>
  <j-editable-table ref="editableTable"
                    :loading="loading"
                    :columns="columns"
                    :dataSource="dataSource"
                    :rowNumber="true"
                    :rowSelection="true"
                    :actionButton="actionButton"
                    :maxHeight="300" />
</template>

<script>

import { FormTypes } from '@/utils/JEditableTableUtil'

export default {
  name: 'IndexTable',
  components: {},
  props: {
    actionButton: {
      type: Boolean,
      default: true,
      required: false
    }
  },
  data() {
    return {
      loading: false,
      dataSource: [],
      columns: [
        {
          title: 'tableHeader.indexName', // 必填
          language_key: 'tableHeader.indexName', // 必填
          key: 'indexName',
          // width: '30%',
          width: '330px',
          type: FormTypes.input,
          defaultValue: '',
          placeholder: this.$t('tip.pleaseInput') + '${language_key}',
          validateRules: [{ required: true, message: '${language_key}' + this.$t('tip.cannotBeEmpty') }]
        },
        {
          title: 'tableHeader.indexField', // 必填
          key: 'indexField',
          // width: '30%',
          width: '330px',
          type: FormTypes.list_multi,
          options: [],
          defaultValue: '',
          placeholder: this.$t('tip.pleaseSelect') + '${language_key}',
          validateRules: [{ required: true, message: this.$t('tip.pleaseSelect') + '${language_key}' }],
          props: {
            'notFoundContent': '没有什么好选择的'
            // 'mode': 'multiple'
          }
        },
        {
          title: 'tableHeader.indexType', // 必填
          key: 'indexType',
          // width: '30%',
          width: '330px',
          type: FormTypes.select,
          options: [
            { title: 'normal', value: 'normal' },
            { title: 'unique', value: 'unique' }
          ],
          defaultValue: 'normal',
          placeholder: this.$t('tip.pleaseSelect') + '${language_key}',
          validateRules: [{ required: true, message: this.$t('tip.pleaseSelect') + '${language_key}' }]
        }
      ]
    }
  },
  methods: {
    /** 同步列表 */
    async syncTable(table1) {
      await table1.$refs.editableTable.getValuesPromise(false).then((values) => {
        let options = []
        values.forEach(value => {
          if (value.dbFieldName) {
            options.push({
              title: value.dbFieldName,
              value: value.dbFieldName
            })
          }
        })
        this.columns[ 1 ].options = options
      })
    }
  }
}
</script>